import { fetchData } from '@umu/umu-fetch';
import { API } from '../api';
import { API as SEARCH_API } from '../../../services/userSearch';
import { ISearchItem } from '../../searchInput/index';
import { IAccountInfo } from '../interface/account';
import { INavInfo } from '../interface/index';
interface ISearchAccountParam {
    accounts: string;
    nav_id?: string;
    se_id?: string;
    search_source: string;
    is_suggestion: string;
}
// USE下人员模糊搜索

const getSearchAccountByKeyword = (params: ISearchAccountParam): Promise<ISearchItem[]> => {
    return fetchData(SEARCH_API.ACCOUNT_SEARCH_V2, params, { silent: true }).then(
        (res: { data: IAccountInfo[] }) => {
            return res.data || [];
        },
        () => {
            return [];
        },
    );
};
const setSeNavPermission = (params: {
    id: string;
    se_id: string;
    access_permission?: string;
    is_open?: number;
}): Promise<{ isSuccess: boolean }> => {
    return fetchData(API.SET_NAV_PERMISSION, params, { silent: true }).then(
        (res: { data: { status: number } }) => {
            return {
                isSuccess: res?.data?.status === 1,
            };
        },
        () => {
            return {
                isSuccess: false,
            };
        },
    );
};
const setSeAccountPermission = (params: Record<string, string>) => {
    return fetchData(API.SET_ACCOUNT_PERMISSION, params, { silent: true }).then(
        (res: { data: IAccountInfo[] }) => {
            return res.data || [];
        },
        () => {
            return [];
        },
    );
};
const getNavBasicInfoById = (params: { id: string; se_id: string }) => {
    return fetchData(API.GET_NAV_BASIC_INFO, params, { silent: true }).then(
        (res: { data: INavInfo }) => {
            return res.data as INavInfo;
        },
        () => {
            return {} as INavInfo;
        },
    );
};
const defaultPermissionMemberList: IList<IAccountInfo> = {
    list: [],
    page_info: {
        current_page: 1,
        list_total_num: 0,
        total_num: 0,
        size: 20,
        total_page_num: 1,
    },
};
const getNavPermissionAccountListById = (params: {
    obj_id: string;
    obj_type: string;
    se_id?: string;
    page: number;
    size: number;
}) => {
    return fetchData(API.GET_NAV_PERMISSION_ACCOUNT_LIST, params, { silent: true }).then(
        (res: IResponse<IList<IAccountInfo>>) => {
            return res.data || defaultPermissionMemberList;
        },
        () => {
            return defaultPermissionMemberList;
        },
    );
};
const getCourseInfo = (params: { group_id: string }) => {
    return fetchData(API.GET_COURSE_INFO, params, { silent: true }).then(
        (res: IResponse<{ info: any }>) => {
            return res.data.info || {};
        },
        () => {
            return {};
        },
    );
};
const getCourseTimingSwitchInfo = (params: { course_id: string }) => {
    return fetchData(API.GET_COURSE_TIMING_SWITCH_INFO, params, { silent: true }).then(
        (res: IResponse<any>) => {
            return res.data || {};
        },
        () => {
            return {};
        },
    );
};
const getProgramInfo = (params: { program_id: string }) => {
    return fetchData(API.GET_PROGRAM_INFO, params, { silent: true }).then(
        (res: IResponse<{ program_info: any }>) => {
            return res.data.program_info || {};
        },
        () => {
            return {};
        },
    );
};
const getMicroPageInfo = (params: { page_id: string; se_id?: string }) => {
    return fetchData(API.GET_MICRO_PAGE_INFO, params, { silent: true }).then(
        (res: IResponse<any>) => {
            return res.data || {};
        },
        () => {
            return {};
        },
    );
};
const getSessionInfo = (params: { session_id: string; se_id?: string }) => {
    return fetchData(API.GET_SESSION_INFO, params, { silent: true }).then(
        (res: IResponse<any>) => {
            return res?.data?.info?.sessionInfo || {};
        },
        () => {
            return {};
        },
    );
};
const getSessionTimingInfo = (params: { session_ids: string; se_id?: string }) => {
    return fetchData(API.GET_SESSION_TIMING_INFO, params, { silent: true }).then(
        (res: IResponse<any>) => {
            return res.data[params.session_ids] || {};
        },
        () => {
            return {};
        },
    );
};
const getCheckNavPermission = (params: Record<string, string>): Promise<{ isPass: boolean }> => {
    return fetchData(API.GET_CHECK_PERMISSION, params, { silent: true }).then(
        (res: { data: { nav_cover_content_permission: number } }) => {
            return {
                isPass: !(Number(res?.data?.nav_cover_content_permission) === 0),
            };
        },
        () => {
            return {
                isPass: false,
            };
        },
    );
};
const getNavUsePlateMemberList = (params: { se_id?: string; page: number; size: number }) => {
    return fetchData(API.GET_NAV_USE_PLATE_MEMBER_LIST, params, { silent: true }).then(
        (res: IResponse<IList<IAccountInfo>>) => {
            return res.data || defaultPermissionMemberList;
        },
        () => {
            return defaultPermissionMemberList;
        },
    );
};
const setCancelPermissionAll = (params: { obj_id: string; obj_type: string }): Promise<{ isSuccess: boolean }> => {
    return fetchData(API.SET_CANCEL_PERMISSION_ALL, params, { silent: true }).then(
        (res: IResponse<{ status: number }>) => {
            return {
                isSuccess: res?.data?.status === 1,
            };
        },
        () => {
            return {
                isSuccess: false,
            };
        },
    );
};
export {
    getCourseInfo,
    setCancelPermissionAll,
    getNavUsePlateMemberList,
    getProgramInfo,
    getMicroPageInfo,
    getSessionInfo,
    getCheckNavPermission,
    getSessionTimingInfo,
    getCourseTimingSwitchInfo,
    defaultPermissionMemberList,
    getSearchAccountByKeyword,
    getNavPermissionAccountListById,
    getNavBasicInfoById,
    setSeNavPermission,
    setSeAccountPermission,
};
